import React from "react";

import { OfferDto, QuantityButtonsWidgetDto } from "@intelligems/ig-types";
import { SxProps } from "@mui/material";
import { UserInterfaceWidgetPreview as Preview } from "@src/features/personalizations/components/offerModifications/widgets/UserInterfaceWidgetPreview";

import { IgQuantityButtons } from "./IgQuantityButtons";
import { QuantityButtonsWidgetPreview } from "./QuantityButtonsWidgetPreview";

interface QuantityWidgetPreviewProps {
  widget: QuantityButtonsWidgetDto;
  offer: OfferDto;
  isEdit?: boolean;
  gridSx?: SxProps;
}

export const QuantityButtonsPreview = ({
  widget,
  offer,
  isEdit,
  gridSx,
}: QuantityWidgetPreviewProps) => {
  if (isEdit)
    return (
      <Preview renderLocation={"settings"}>
        <Preview.Label label={"Preview"} />
        <Preview.Widget device={"desktop"} renderLocation={"settings"}>
          <IgQuantityButtons device={"desktop"} widget={widget} offer={offer} />
        </Preview.Widget>
      </Preview>
    );

  return (
    <QuantityButtonsWidgetPreview widget={widget} isEdit={isEdit}>
      <IgQuantityButtons
        gridSx={gridSx}
        device={"desktop"}
        widget={widget}
        offer={offer}
      />
    </QuantityButtonsWidgetPreview>
  );
};
